<template>
  <div>
    <div class="o-panel" v-if="open" v-bind:class="{ 'o-panel--open': this.open }">
      <div class="o-panel__head">
        <h2 class="o-panel__title">{{ title }}</h2>
        <button v-if="isClosable" type="button" class="o-panel__close" @click="close">{{ $t('panel-close') }}</button>
      </div>
      <div class="o-panel__content">
        <div class="h-remove-child-margin">
          <p v-if="text && text.trim()" v-html="text" />
          <slot />
        </div>
      </div>
    </div>
    <div class="o-panel__overlay" @click="close"></div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    isClosable: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    open: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    close: function() {
      if (this.isClosable) {
        this.open = false
      }
    }
  }
}
</script>
